import { Overlay } from 'components/Overlay';
import { ColorPicker } from 'controller/components/ColorPicker';
import { ColorTheme } from 'data/ColorTheme';
import * as React from 'react';
import { addColorTheme } from 'state/actions';
import { storeDispatch } from 'state/Store';

const ColorRow: React.FC<{
  label: string;
  value: string;
  onChange: (c: string) => void;
}> = ({ label, value, onChange }) => {
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        textAlign: 'left',
        alignItems: 'center',
        margin: '20px 0'
      }}
    >
      <div style={{ flexGrow: 1, marginRight: 8 }}>{label}</div>
      <div style={{ width: 300 }}>
        <ColorPicker color={value} onChange={onChange} hideAlpha={true} />
      </div>
    </div>
  );
};

const PreviewRow: React.FC<{ theme: ColorTheme }> = ({ theme }) => {
  return (
    <div
      style={{
        margin: '20px 0'
      }}
    >
      <div
        style={{
          backgroundColor: theme.background,
          color: theme.foreground,
          border: '1px solid rgba(var(--menu-fg-rgb), 0.1)',
          borderRadius: 4,
          fontSize: 24,
          lineHeight: '64px',
          fontWeight: 500,
          textAlign: 'center'
        }}
      >
        Create <span style={{ color: theme.accent }}>eye-catching</span> posts
      </div>
    </div>
  );
};

export const AddColorThemeModal: React.FC = () => {
  const [isAdding, setIsAdding] = React.useState(false);
  const [accent, setAccent] = React.useState('#FFFFFF');
  const [foreground, setForeground] = React.useState('#9B8FFF');
  const [background, setBackground] = React.useState('#340B0B');

  const saveTheme = React.useCallback(() => {
    setIsAdding(true);
    storeDispatch(addColorTheme({ accent, background, foreground }));
  }, [accent, foreground, background]);

  return (
    <Overlay title="Add color theme">
      <PreviewRow theme={{ accent, background, foreground }} />
      <ColorRow
        label="Foreground:"
        value={foreground}
        onChange={setForeground}
      />
      <ColorRow label="Accent:" value={accent} onChange={setAccent} />
      <ColorRow
        label="Background:"
        value={background}
        onChange={setBackground}
      />
      <button
        className="primary large"
        onClick={isAdding ? undefined : saveTheme}
        disabled={isAdding}
      >
        {isAdding ? 'Saving...' : 'Save'}
      </button>
    </Overlay>
  );
};



// WEBPACK FOOTER //
// ./src/account/AddColorThemeModal.tsx